import { Badge, Box, Tooltip, Text } from "@mantine/core";
import {
  MRT_ColumnDef,
  MRT_RowSelectionState,
  MantineReactTable,
  useMantineReactTable,
} from "mantine-react-table";
import * as React from "react";
import { useEffect, useState } from "react";
import { _timerDelayClick } from "../../../_base/_const/_constVar";
import { _localization } from "../../../config/location";
import "../../../Styles/tab.component.css";
import { formatDateTransfer } from "../../../common/FormatDate/FormatDate";
import { green } from "../../../const/variables";

const DetailProductWarranty = ({
  dataDetail,
  processingMethod,
  typeProduct,
}: {
  dataDetail: any;
  processingMethod: any;
  typeProduct: any;
}) => {
  //data and fetching state
  const [data] = useState<any[]>(dataDetail);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  //table state
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [selectIds, setSelectIds] = useState<string[]>([]);
  //count
  const [timeLeft, setTimeLeft] = useState(60);
  const [isCounting, setIsCounting] = useState(false);

  const columns = React.useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        accessorKey: "itemCode",
        header: "Mã sản phẩm",
        Cell: ({ renderedCellValue }) => (
          <Badge
            radius="sm"
            variant="dot"
            size="lg"
            color={renderedCellValue === null ? "red" : green.base}
          >
            {renderedCellValue === null ? null : renderedCellValue}
          </Badge>
        ),
        size: 200,
      },
      // {
      //   accessorKey: "attribute1",
      //   header: "Mã sản phẩm",
      //   Cell: ({ renderedCellValue }) => (
      //     <Badge
      //       radius="sm"
      //       variant="dot"
      //       size="lg"
      //       color={renderedCellValue === null ? "red" : green.base}
      //     >
      //       {renderedCellValue === null ? null : renderedCellValue}
      //     </Badge>
      //   ),
      //   size: 200,
      // },
      // {
      //   accessorKey: "attribute2",
      //   header: "Tên sản phẩm",
      //   Cell: ({ row }) => (
      //     <Box w={350}>
      //       <Tooltip label={row.original.attribute2}>
      //         <Text size="12.5px" fw={500} truncate="end" h={15}>
      //           {row.original.attribute2}
      //         </Text>
      //       </Tooltip>
      //     </Box>
      //   ),
      // },
      {
        accessorKey: "itemName",
        header: "Tên sản phẩm",
        Cell: ({ row }) => (
          <Box w={350}>
            <Tooltip label={row.original.itemName}>
              <Text size="12.5px" fw={500} truncate="end" h={15}>
                {row.original.itemName}
              </Text>
            </Tooltip>
          </Box>
        ),
      },
      {
        accessorKey: "serial",
        header: "Serial",
      },
      {
        accessorKey: "buyingDate",
        header: "Ngày mua",
        Cell: ({ renderedCellValue }: any) => (
          <>{renderedCellValue && formatDateTransfer(renderedCellValue)}</>
        ),
        size: 200,
      },
      {
        accessorKey: "listErrorCode",
        header: "Ghi nhận lỗi ban đầu",
        size: 225,
      },
      {
        accessorKey: "conclusionError",
        header: "Diễn giải",
        size: 200,
      },
      {
        accessorKey: "resolution",
        header: "Cách khắc phục",
        size: 200,
      },
      {
        accessorKey: "attribute10",
        header: "Trạng thái xử lý",
        Cell: ({ renderedCellValue }) => (
          <Text fw={500} size="12.5px">
            {renderedCellValue === "TRA_KHACH"
              ? "Trả khách"
              : renderedCellValue === "NHAP_KHO"
                ? "Nhập kho"
                : renderedCellValue === "TU_VAN"
                  ? "Tư vấn"
                  : ""}
          </Text>
        ),
      },
      {
        accessorKey: "handleDate",
        header: "Ngày xử lý",
        size: 200,
        Cell: ({ renderedCellValue }: any) => (
          <>{renderedCellValue && formatDateTransfer(renderedCellValue)}</>
        ),
      },
      {
        accessorKey: "note",
        header: "Ghi chú",
        size: 200,
      },
    ],
    [],
  );

  // const getColumnVisibility = (type: string) => {
  //   if (type === "HANG_NGOAI") {
  //     return {
  //       itemName: false,
  //       itemCode: false,
  //       attribute1: true,
  //       attribute2: true,
  //     };
  //   } else if (type === "HANG_HACOM") {
  //     return {
  //       itemName: true,
  //       itemCode: true,
  //       attribute1: false,
  //       attribute2: false,
  //     };
  //   }

  //   return {
  //     itemName: false,
  //     itemCode: false,
  //     attribute1: false,
  //     attribute2: false,
  //   };
  // };

  useEffect(() => {
    let timer: ReturnType<typeof setInterval>;
    if (isCounting && timeLeft > 0) {
      timer = setInterval(() => {
        setTimeLeft((prevTime) => prevTime - 1);
      }, 1000);
    } else if (timeLeft === 0) {
      setIsCounting(false);
    }
    return () => clearInterval(timer);
  }, [isCounting, timeLeft]);

  useEffect(() => {
    const valuesList = Object.keys(rowSelection);
    setSelectIds(valuesList);
    if (valuesList.length < 1) setSelectIds([]);
    else {
      const valuesList = Object.keys(rowSelection);
      setSelectIds(valuesList);
    }
  }, [rowSelection]);

  const table = useMantineReactTable({
    columns,
    data,
    positionToolbarAlertBanner: "bottom",
    columnFilterDisplayMode: "popover",
    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    localization: _localization,
    enableRowSelection: false,
    enablePagination: false,
    enableBottomToolbar: false,
    enableTopToolbar: false,
    getRowId: (row) => row.id,
    initialState: {
      showColumnFilters: false,
      columnVisibility: { id: false },
      density: "xs",
    },
    mantineTableContainerProps: {
      style: { maxHeight: 500, minHeight: 100 },
    },
    enableStickyHeader: true,
    onRowSelectionChange: setRowSelection,
    rowCount,
    mantineTableBodyCellProps: ({ row }) => ({
      style: {
        //  fontWeight: row.getIsSelected() ? "bold" : "normal", //conditional styling
        fontWeight: "500", //conditional styling
        fontSize: "12.5px",
        padding: "5px 15px",
      },
    }),
    mantineTableProps: () => ({
      striped: true,
    }),
    state: {
      // columnFilters,
      // globalFilter,
      isLoading,
      //  pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading, //loading for the first time with no data
      //sorting,
      rowSelection,
    },
    mantineToolbarAlertBannerProps: isError
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      rowsPerPageOptions: ["10", "50", "100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableBodyRowProps: ({ row }) => ({
      onClick: row.getToggleSelectedHandler(),
      sx: { cursor: "pointer" },
    }),
  });

  // React.useEffect(() => {
  //   const newColumnVisibility = getColumnVisibility(typeProduct ?? "");
  //   if (table) {
  //     table.setColumnVisibility(newColumnVisibility);
  //   }
  // }, [typeProduct, table]);

  return (
    <>
      <MantineReactTable table={table} />
    </>
  );
};

export default DetailProductWarranty;
